module.exports = __webpack_public_path__ + "../resources/img/bg_load1_03.010f5263.png";